import OnboardingService from '@forwardflow/services/OnboardingService'
import useSWR from 'swr'

export default function useSetupProgress() {
   const response = useSWR(
      '/onboarding/setup-progress',
      OnboardingService.getOnboardingProgress
   )
   return {
      ...response,
   }
}
